import { useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Botao } from '../../componentes/base';
import { Estado } from '../../componentes/estados';
import { Rotulo, Selecao } from '../../componentes/formulario';
import { Modal } from '../../componentes/sobreposicao';
import { useToast } from '../../componentes/toast';
import { api, get, getTodos, mensagemDeErro } from '../../nucleo/api';

interface Config {
  responsavel_id: string | null;
  responsavel_nome: string | null;
}

/**
 * Val1 (ficha 2026-10-28 `FUN_cadastro-previo-funcionario-e-situacao-de-acesso`): quem recebe o aviso e o card em Tarefas a
 * cada funcionário cadastrado com dados a complementar. Sem responsável, vão para todos com acesso ao RH/DP (`pessoas.editar`).
 */
export function ResponsavelCadastro({ aoFechar }: { aoFechar: () => void }) {
  const { t } = useTranslation('pessoas');
  const { t: tn } = useTranslation();
  const qc = useQueryClient();
  const toast = useToast();
  const cfg = useQuery({ queryKey: ['pessoas', 'cadastro-previo'], queryFn: () => get<Config>('/pessoas/cadastro-previo') });
  const membros = useQuery({ queryKey: ['pessoas', 'membros'], queryFn: () => getTodos<{ id: string; nome: string }>('/membros').then((r) => r.itens) });
  const [escolha, setEscolha] = useState<string | null | undefined>(undefined);
  const valor = escolha === undefined ? (cfg.data?.responsavel_id ?? '') : (escolha ?? '');
  const salvar = useMutation({
    mutationFn: () => api('PUT', '/pessoas/cadastro-previo', { responsavel_id: valor || null }),
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: ['pessoas', 'cadastro-previo'] });
      toast.sucesso(tn('comum.salvo'));
      aoFechar();
    },
    onError: (e) => toast.erro(mensagemDeErro(e)),
  });
  return (
    <Modal
      aberto
      aoFechar={aoFechar}
      titulo={t('responsavel.titulo')}
      rodape={
        <>
          <Botao variante="fantasma" onClick={aoFechar}>
            {tn('comum.cancelar')}
          </Botao>
          <Botao variante="primario" carregando={salvar.isPending} disabled={!cfg.data} onClick={() => salvar.mutate()}>
            {tn('comum.salvar')}
          </Botao>
        </>
      }
    >
      <div className="flex flex-col gap-3" data-responsavel-cadastro="">
        <p className="text-sm text-tinta-2">{t('responsavel.ajuda')}</p>
        <Estado consulta={membros}>
          {(lista) => (
            <Rotulo id="responsavel-cadastro" rotulo={t('responsavel.campo')}>
              <Selecao id="responsavel-cadastro" vazio={t('responsavel.todos')} value={valor} onChange={(e) => setEscolha(e.target.value || null)} opcoes={lista.map((m) => ({ valor: m.id, rotulo: m.nome }))} />
            </Rotulo>
          )}
        </Estado>
      </div>
    </Modal>
  );
}
